// Copyright (C) 2022 Cochise Ruhulessin
//
// All rights reserved. No warranty, explicit or implicit, provided. In
// no event shall the author(s) be liable for any claim or damages.
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
import { IonButton } from "@ionic/react"


interface CancelButtonProps {
  onClick?: () => void
  title: string
}


const CancelButton: React.FC<CancelButtonProps> = ({title, ...props}) => {
  const onClick = props.onClick || (() => {})
  return (
    <IonButton
      color="danger"
      fill="clear"
      onClick={onClick}
      style={{minHeight: "55px", width: "100%"}}
    >
      {title}
    </IonButton>
  )
}


export default CancelButton